import { inject, Injectable } from '@angular/core';
import { selectMetadatasLoaded } from '@mkp/metadata/state';
import { MetadataActions } from '@mkp/metadata/state/actions';
import { select, Store } from '@ngrx/store';
import { noop, Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetadatasResolver {
  private store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.pipe(
      select(selectMetadatasLoaded),
      tap((loaded) => (!loaded ? this.store.dispatch(MetadataActions.getMetadatasList()) : noop())),
      filter((loaded) => !!loaded),
      take(1)
    );
  }
}
